import styled from "styled-components";

export const SocialIcon = styled.svg`
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
    transition: all 0.2s ease-in-out;
  }
`;
